import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

const getAuthHeaders = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  if (!user?.token) {
    throw new Error("Authentication token is missing or invalid");
  }
  return {
    Authorization: `Bearer ${user.token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  };
};

export const holidaysearchresult = createAsyncThunk(
  "holiday/holidaysearchresult",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(`/holiday/searchresult`, payload, { headers: getAuthHeaders() });

      return {
        data: response.data,
      };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to fetch holiday results",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const holidaysearchThemes = createAsyncThunk(
  "holiday/holidaysearchThemes",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(`/holiday/search-by-themes`, payload, { headers: getAuthHeaders() });

      return {
        data: response.data,
      };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to fetch holiday results",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const getavailableDestination = createAsyncThunk("holiday/available-destination", async ({ postData }, { rejectWithValue }) => {
  try {
    // API call to validate fare
    const response = await api.post(`/holiday/available-destination`, postData, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const getDetails = createAsyncThunk("holiday/details", async ({ updatedPostData }, { rejectWithValue }) => {
  try {
    // API call to validate fare
    const response = await api.post(`/holiday/v2/details`, updatedPostData, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const getAddOn = createAsyncThunk("holiday/addonservice", async ({ postData }, { rejectWithValue }) => {
  try {
    // API call to validate fare
    const response = await api.post(`/holiday/v2/addonservice`, postData, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const getcheckAvailability = createAsyncThunk("holiday/check-availability", async ({ inquiryData }, { rejectWithValue }) => {
  try {
    // API call to validate fare
    const response = await api.post(`/holiday/check-availability`, inquiryData, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const fetchbookingcalendarHoliday = createAsyncThunk(
  "holiday/bookingcalendar",
  async ({ FilterData, perPage, cursor = null }, { rejectWithValue }) => {
    try {
      let url = `/holiday/bookingcalendar?per_page=${perPage}`;
      if (cursor) {
        url += `&cursor=${encodeURIComponent(cursor)}`;
      }
      const response = await api.post(url, FilterData, { headers: getAuthHeaders() });
      return { data: response.data };
    } catch (error) {
      // if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
      //   localStorage.removeItem('user');
      //   window.location.reload();
      // }
      return rejectWithValue({
        message: error?.response?.message || "Failed to validate fare",
        status: error.response?.data?.status,
        data: error.response?.data,
      });
    }
  }
);
export const bookingdetails = createAsyncThunk("holiday/bookingdetails", async ({ FormData }, { rejectWithValue }) => {
  try {
    const response = await api.post(`/holiday/bookingdetails`, FormData, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const DopackagePayPending = createAsyncThunk(
  'holiday/package-pay-pending',
  async ({ payload }, { rejectWithValue }) => {
    try {
      // API call to validate fare
      const response = await api.post(
        `/holiday/package-pay-pending`,
        payload,
        { headers: getAuthHeaders() }
      );

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || 'Failed to proceed top up',
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const DoSendVoucher = createAsyncThunk("holiday/sendvoucher", async ({ formData, BookingURLID }, { rejectWithValue }) => {
  try {
    // API call to validate fare
    const response = await api.post(`/holiday/sendvoucher/${BookingURLID}`, formData, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
const HolidaySlice = createSlice({
  name: "holiday",
  initialState: {
    data: null,
    bookingHolidayStatus: "idle",
    datathemes: null,
    results: null,
    bookingcalendar: [],
    loading: false,
    DetailsLoading: true,
    loadingthemes: false,
    resultLoading: true,
    error: null,
    errorthemes: null,
  },
  reducers: {
    clearHolidayData: (state) => {
      state.data = null;
      state.bookingHolidayStatus = "idle";
      state.datathemes = null;
      state.results = null;
      state.bookingcalendar = [];
      state.error = null;
      state.errorthemes = null;
      state.loading = false;
      state.DetailsLoading = false;
      state.loadingthemes = false;
      state.resultLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(holidaysearchresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      }).addCase(holidaysearchresult.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.interNationalSearch = action.payload.interNationalSearch;
        state.routeType = action.payload.routeType;
      }).addCase(holidaysearchresult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something went wrong";
      }).addCase(holidaysearchThemes.pending, (state) => {
        state.loadingthemes = true;
        state.errorthemes = null;
      }).addCase(holidaysearchThemes.fulfilled, (state, action) => {
        state.loadingthemes = false;
        state.datathemes = action.payload.data;
        state.interNationalSearch = action.payload.interNationalSearch;
        state.routeType = action.payload.routeType;
      }).addCase(holidaysearchThemes.rejected, (state, action) => {
        state.loadingthemes = false;
        state.errorthemes = action.payload?.message || "Something went wrong";
      }).addCase(fetchbookingcalendarHoliday.pending, (state, action) => {
        state.bookingHolidayStatus = "loading";
      })
      .addCase(fetchbookingcalendarHoliday.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.bookingHolidayStatus = data.status.success;
        state.bookingcalendar = data || {};
      }).addCase(bookingdetails.pending, (state) => {
        state.DetailsLoading = true;
        state.error = null;
      })
      .addCase(bookingdetails.fulfilled, (state, action) => {
        state.DetailsLoading = false;
        state.bookingdetails = action.payload.data;
      })
      .addCase(bookingdetails.rejected, (state, action) => {
        state.DetailsLoading = false;
        state.error = action.payload?.message || "Failed to fetch results";
      });
  },
});

export const { clearHolidayData } = HolidaySlice.actions;
export const selectresultLoading = (state) => state.hotel.resultLoading;
export const selectHolidayState = (state) => state.holiday || {};

// ✅ PACKAGES ARRAY (NORMALIZED)
export const selectHolidayPackages = (state) => state.holiday?.data?.data?.data || [];

// ✅ LOADING STATE
export const selectHolidayLoading = (state) => state.holiday?.loading || false;
export const selectDetailsLoading = (state) => state.holiday.DetailsLoading;
export const selectbookingdetails = (state) => state.holiday.bookingdetails;
// ✅ META (OPTIONAL, FOR PAGINATION)
export const selectHolidayMeta = (state) => state.holiday?.data?.data?.meta || {};
export default HolidaySlice.reducer;
